import { NgView } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { DialogService } from "@app/services/dialog.service";
import { BaseController } from "@app/views/base.view";
import { IAlert, IDialog } from "@models";

export interface IDialogModel {
    alerts: IAlert[];
    dialogs: IDialog[];
}

export interface IDialogViewScope extends ng.IScope {
    model: IDialogModel;
    closeAlert: (index: number) => void;
}

@NgView({
    token: Token.DialogView,
    dependencies: [
        Token.$Scope,
        Token.DialogService,
    ]
})
export class DialogController extends BaseController {

    constructor(
        public $scope: IDialogViewScope,
        public dialogService: DialogService
    ) {

        super();

        $scope.model = {
            alerts: dialogService.alerts,
            dialogs: dialogService.dialogs
        };

        $scope.closeAlert = index => {
            dialogService.closeAlert(index);
        };
    }
}
